


















import { defineComponent, PropType, ref, computed, onMounted, onBeforeUnmount } from '@nuxtjs/composition-api';
import { throttle } from 'lodash-es';
import ProductDetailSetItemCartButton from '~/components/pages/Product/Detail/ProductDetailSetItemCartButton.vue';
import { useStore } from '~/composables/useStore';
import { FLEXIBLE_SET_ITEM_SECTION_ANCHOR_POINT } from '~/constants';
import { ProductShowECResponseSchema } from '~/types/modules/product';

export default defineComponent({
  components: {
    ProductDetailSetItemCartButton,
  },
  props: {
    ecResponse: {
      type: Object as PropType<ProductShowECResponseSchema>,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const isItemsSectionPassed = ref(false);
    const selectedTotal = computed(() =>
      store.state.product.detail.selectedFlexibleSetItems.reduce(
        (totalCount: number, currentItem) => totalCount + currentItem.quantity,
        0
      )
    );
    const totalLimit = computed(
      () => props.ecResponse.product_variants?.find((productVariant) => productVariant.set_items)?.set_item_limit || 0
    );

    // 商品選ぶ領域以下が画面に入ったらフッタバーを表示する
    const updateFlexibleSetItemFooterVisibility = throttle(() => {
      const flexibleSetItemSectionRect = document
        .getElementById(FLEXIBLE_SET_ITEM_SECTION_ANCHOR_POINT)
        ?.getBoundingClientRect();
      isItemsSectionPassed.value =
        window.innerHeight > (flexibleSetItemSectionRect?.top || 0) + store.state.internals.header.headerHeight;
    }, 100);

    onMounted(() => {
      window.addEventListener('scroll', updateFlexibleSetItemFooterVisibility);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('scroll', updateFlexibleSetItemFooterVisibility);
    });

    return {
      isItemsSectionPassed,
      selectedTotal,
      totalLimit,
      FLEXIBLE_SET_ITEM_SECTION_ANCHOR_POINT,
    };
  },
});
